(() => {
  document.querySelectorAll('.wg-content a[download]').forEach(link => {
    let busy = false;
    link.addEventListener('click', async event => {
      if (event.button > 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (busy) return;
      busy = true;
      const label = link.textContent;
      link.textContent = 'Preparing PDF…';
      link.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(link.href);
        if (!response.ok) throw new Error('PDF unavailable');
        const url = URL.createObjectURL(await response.blob());
        const download = document.createElement('a');
        download.href = url;
        download.download = link.getAttribute('download');
        download.hidden = true;
        document.body.append(download);
        download.click();
        download.remove();
        setTimeout(() => URL.revokeObjectURL(url), 10000);
      } catch {
        window.location.assign(link.href);
      } finally {
        link.textContent = label;
        link.removeAttribute('aria-busy');
        busy = false;
      }
    });
  });
})();
